import EditableRoundsTab from "./EditableRoundsTab"

export default function LIATab({ assetId, active }: { assetId: number; active: boolean }) {
  return (
    <EditableRoundsTab
      assetId={assetId}
      active={active}
      contractType="LIA"
      emptyMessage="No LIA rounds available for this asset."
    />
  )
}
